import React from 'react'
import formatPhone from '../../Shared/utils/formatPhone'

export const PhoneNumber = ({number}) => {
  return (
    <span>  {formatPhone(number)}  </span>
  )
}
